import { useCallback } from 'react'
import { useGetMedicalReportLazyQuery } from './medicalReport.generated'

export function useMedicalReport(uid: string) {
  const [getMedicalReport, { loading }] = useGetMedicalReportLazyQuery({
    variables: { uid },
  })

  const exportMedicalReport = useCallback(async () => {
    const result = await getMedicalReport()

    if (result.error) {
      throw result.error
    }

    if (!result.data?.patient?.medicalReport?.url) {
      throw new Error('Failed to generate medical report. Please try again.')
    }

    return {
      url: result.data.patient.medicalReport.url,
      warning: result.data.patient.medicalReport.warning ?? null,
    }
  }, [getMedicalReport])

  return { exportMedicalReport, loading }
}
